import {useApiRemove} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornService} from "../../../../../application/business/StubbornAsset";

export const useEditionServiceRemove = () => useApiRemove<StubbornService>(PATH);
